import { MathHelper } from "@/Common/Helpers/MathHelper";
import { HeightUnit } from "./Units";

export class HeightUnitConverter {
    private static readonly centimetersPerInch = 2.54; // 1inch = 2.54cm
    private static readonly centimetersPerMeter = 100; // 1m = 100cm

    public static convert(from: HeightUnit, to: HeightUnit, height: number, numberOfDecimals?: number): number {
        if (!height || IsNullOrUndefined(from) || IsNullOrUndefined(to))
            return null;

        let value: number;

        switch (from) {
            case HeightUnit.Meter:
                value = this.convertMeterTo(to, height);
                break;
            case HeightUnit.Inch:
                value = this.convertInchTo(to, height);
                break;
            case HeightUnit.Centimeter:
                value = this.convertCentimeterTo(to, height);
                break;
        }

        return numberOfDecimals ? MathHelper.roundToDecimals(value, numberOfDecimals) : value;
    }

    public static convertCentimeterTo(to: HeightUnit, height: number): number {
        switch (to) {
            case HeightUnit.Inch:
                return this.centimeterToInch(height);
            case HeightUnit.Meter:
                return this.centimeterToMeter(height);
            default:
                return height;
        }
    }

    public static convertMeterTo(to: HeightUnit, height: number): number {
        switch (to) {
            case HeightUnit.Inch:
                return this.meterToInch(height);
            case HeightUnit.Centimeter:
                return this.meterToCentimeter(height);
            default:
                return height;
        }
    }

    public static convertInchTo(to: HeightUnit, height: number): number {
        switch (to) {
            case HeightUnit.Centimeter:
                return this.inchToCentimeter(height);
            case HeightUnit.Meter:
                return this.inchToMeter(height);
            default:
                return height;
        }
    }

    public static inchToCentimeter(valueInInch: number): number {
        return valueInInch * this.centimetersPerInch;
    }

    public static inchToMeter(valueInInch: number): number {
        return this.centimeterToMeter(this.inchToCentimeter(valueInInch));
    }

    public static meterToInch(valueInMeter: number): number {
        return this.meterToCentimeter(valueInMeter) / this.centimetersPerInch;
    }

    public static centimeterToMeter(valueInCm: number): number {
        return valueInCm / this.centimetersPerMeter;
    }

    public static centimeterToInch(valueInCm: number): number {
        return valueInCm / this.centimetersPerInch;
    }

    public static meterToCentimeter(valueInMeter: number): number {
        return valueInMeter * this.centimetersPerMeter;
    }
}
